module.exports = __webpack_public_path__ + "static/media/Akali.25417151.png";